import React from "react";
import styled from "styled-components";

import * as Domain from "helpers/domain";
import {getLanguage} from "helpers/getLanguage";
import BannerImage from "assets/svg/banner.svg";
import LogoImage from "assets/png/paribas-fortis.png";
import FintroBannerImage from "assets/svg/fintro/banner.svg";
import FintroLogoImageFR from "assets/svg/fintro/fintro-logo-fr.svg";
import FintroLogoImageNL from "assets/svg/fintro/fintro-logo-nl.svg";

const getFintroLogo = () => {
    if(getLanguage() === 'NL') {
        return FintroLogoImageNL;
    }

    return FintroLogoImageFR;
}

const BannerWrapper = styled.div`
    display: none;
    height: 108px;
    width: 100%;
    background: #f7faeb;

    ${({theme}) => theme.media.desktop`
        display: block;
    `};
`;

const Banner = styled.div<{image:string}>`
    background: url(${props => props.image}) left 0;
    height: 100%;
`;

const LogoWrapper = styled.div`
    display: none;
    padding: 1em;
    background-color: #fff;

    ${({theme}) => theme.media.desktop`
        display: block;
    `};
`;

const Logo = styled.img`
    display: block;
    height: 3.19em;
`;

export const Header = () => {
    const isFintro = Domain.isFintro();
    return (
        <>
            <LogoWrapper>
                {isFintro && (
                    <Logo src={getFintroLogo()} alt="Fintro"/>
                )}
                {!isFintro && (
                    <Logo src={LogoImage} alt="BNP Paribas Fortis"/>
                )}

            </LogoWrapper>
            <BannerWrapper>
                <Banner image={isFintro ? FintroBannerImage : BannerImage} />
            </BannerWrapper>
        </>
    )
}
